// extracted by mini-css-extract-plugin
export default {"scroll":"Scroll_scroll__Nould"};